import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Student } from 'core/models';
import { DynamicFormComponent, ModalComponent, QuestionBase, TextboxQuestion } from 'core/components';
import { UsersService } from 'core/services';

@Component({
  selector: 'lms-student-email-editor',
  templateUrl: './student-email-editor.component.html',
  styleUrls: ['./student-email-editor.component.scss']
})
export class StudentEmailEditorComponent {
  @Input() student: Student;
  @Output() studentEmailChanged = new EventEmitter<string>();
  @ViewChild(ModalComponent, { static: false }) public modal: ModalComponent;
  @ViewChild('emailUpdateForm', { static: false }) public dynamicForm: DynamicFormComponent;

  public questions: QuestionBase<any>[];
  public step: string;
  public confirmationMessageLabel: string;
  public newEmail: string;

  constructor(public usersService: UsersService) {}

  public open() {
    this.step = 'form';
    this.questions = [
      new TextboxQuestion({
        key: 'email',
        label: 'nouns.email',
        value: this.student.email
      })
    ];
    this.modal.open();
  }

  public close() {
    this.modal.close();
  }

  public submit(email: string, emailUpdateConfirmed = false) {
    this.usersService
      .updateEmail(this.student.id, email, emailUpdateConfirmed)
      .then((data) => {
        this.close();
        this.studentEmailChanged.emit(data.email);
      })
      .catch((error) => {
        if (error.responseStatusCode === 428) {
          // This student has multiple accounts, so we must ask for confirmation
          const { hasMultipleAccounts, isAlsoAnAdmin } = error.payload;
          this.confirmationMessageLabel = hasMultipleAccounts
            ? isAlsoAnAdmin
              ? 'students.updateEmail.hasMultipleAccountsAndIsAdmin'
              : 'students.updateEmail.hasMultipleAccounts'
            : 'students.updateEmail.isAdmin';

          this.newEmail = email;
          this.step = 'confirmation';
        } else {
          this.step = 'error';
        }
      });
  }
}
